module.exports = __webpack_public_path__ + "assets/1e6ecb203dd5cb7c2ef6c1ddb64bcd92.png";